import { Button, IconButton, Tooltip } from "@mui/material";
import VerticalSplitIcon from "@mui/icons-material/VerticalSplit";
import ViewModuleIcon from "@mui/icons-material/ViewModule";

import { useUiFlag } from "../../hooks/useUiFlag";
import { LISTING_TOUR_ANCHOR } from "./listingTour";

/**
 * Switch between the map + list view and the classic tiles/map page. The
 * choice is a per-user ui_flag, so it follows the person across browsers.
 */
export default function LayoutToggle() {
  const { value, set } = useUiFlag("projectListingLayout");
  if (value === "classic") {
    return (
      <Button
        size="small"
        variant="outlined"
        startIcon={<VerticalSplitIcon />}
        onClick={() => set("split")}
        sx={{ textTransform: "none", whiteSpace: "nowrap" }}
      >
        Back to the new view
      </Button>
    );
  }
  return (
    <Tooltip title="Switch to the classic tile view">
      <IconButton
        data-tour={LISTING_TOUR_ANCHOR.layoutToggle}
        onClick={() => set("classic")}
        aria-label="Switch to the classic tile view"
      >
        <ViewModuleIcon />
      </IconButton>
    </Tooltip>
  );
}
